import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tPackageModel } from '../models/tPackageModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';



@Injectable({
    providedIn: 'root'
})

export class tPackageService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tPackageModels';

    getAllData() {
        return this.http.get<tPackageModel[]>(this.baseurl + this.pathName);
    }


    getActiveData() {
        return this.http.get<tPackageModel[]>(this.baseurl + this.pathName + '/GetActivePackage');
    }

    // getAllDataWithItemInfo() {
    //     return this.http.get<tPackageModel[]>(this.baseurl + this.pathName + '/WithItemInfo');
    // }

    getDataById(shopID: string, packID: string) {
        return this.http.get<tPackageModel>(this.baseurl + this.pathName + '/WithItemInfo/' + shopID + '/' + packID);
    }

    getDataByIdNonItem(shopID: string, packID: string) {
        return this.http.get<tPackageModel>(this.baseurl + this.pathName + '/NonItem/' + shopID + '/' + packID);
    }

    addData(data: tPackageModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted', data);
    }

    deleteData(data: tPackageModel) {
        return this.http.delete(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.packID);
    }

    updateData(data: tPackageModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.packID, data);
    }

    packageIsUsed(packageID: string) {
        return this.http.get<boolean>(this.baseurl + this.pathName +'/GetPackageIsUsed/'+NavigationComponent.selectedShopID.toString()+'/'+packageID);
    }
}